{
  "decrease": "Намаляване {fieldLabel}",
  "increase": "Усилване {fieldLabel}",
  "numberField": "Номер на полето"
}
